'use client';
import { Text as SharedText } from '@launchstore/shared-puck';
import type { TextProps } from '@launchstore/shared-puck';
export const Text: any = SharedText;
export type { TextProps };
export default Text;
